export const SHOPIFY_PROOF_STORAGE_KEY = 'shopify_main_signup_proof'
export const SHOPIFY_SHOP_STORAGE_KEY = 'shopify_pending_shop'

export const readShopifySignupProof = (query = {}) => {
  const fromQuery = typeof query.shopifyProof === 'string' ? query.shopifyProof.trim() : ''
  if (fromQuery) return fromQuery
  if (typeof window === 'undefined' || !window.sessionStorage) return ''
  return window.sessionStorage.getItem(SHOPIFY_PROOF_STORAGE_KEY) || ''
}

export const readShopifySignupShop = (query = {}) => {
  const fromQuery = typeof query.shop === 'string' ? query.shop.trim().toLowerCase() : ''
  if (fromQuery) return fromQuery
  if (typeof window === 'undefined' || !window.sessionStorage) return ''
  return (window.sessionStorage.getItem(SHOPIFY_SHOP_STORAGE_KEY) || '').toLowerCase()
}

export const storeShopifySignupProof = ({ proof, shop }) => {
  if (typeof window === 'undefined' || !window.sessionStorage) return
  if (shop) window.sessionStorage.setItem(SHOPIFY_SHOP_STORAGE_KEY, shop)
  if (proof) window.sessionStorage.setItem(SHOPIFY_PROOF_STORAGE_KEY, proof)
}

export const appendShopifySignupProof = (url, { proof, shop } = {}) => {
  if (!proof) return url
  const separator = url.includes('?') ? '&' : '?'
  let next = `${url}${separator}shopifyProof=${encodeURIComponent(proof)}`
  if (shop) next += `&shop=${encodeURIComponent(shop)}`
  return next
}

export const shopifyProofTokenFields = (query = {}) => {
  const shopifyProof = readShopifySignupProof(query)
  const shop = readShopifySignupShop(query)
  if (!shopifyProof) return {}
  return shop ? { shopifyProof, shop } : { shopifyProof }
}
